import stackStyles from '../components/sections/stack-section/StackList.module.css'

// A "tone" is a Primer color bucket that a stack entry's vertical timeline line
// segment is drawn in, matching its status icon's color. Shared by the
// effective-entry (`get-effective-entry-line-class`) and rebase
// (`rebase-state-line-class`) line-class helpers.
export type LineTone = 'default' | 'muted' | 'attention' | 'danger' | 'success' | 'done'

// Tone classes set the corresponding CSS custom property on the `<li>` so the
// `::before` and inner `<a>::after` line segments can pick it up. Two parallel
// class families (above/below) let each segment between two icons match the
// upper entry's color end-to-end (rather than splitting at the icon).
export const LINE_ABOVE_CLASS: Record<LineTone, string> = {
  default: stackStyles.lineAboveDefault,
  muted: stackStyles.lineAboveMuted,
  attention: stackStyles.lineAboveAttention,
  danger: stackStyles.lineAboveDanger,
  success: stackStyles.lineAboveSuccess,
  done: stackStyles.lineAboveDone,
}

export const LINE_BELOW_CLASS: Record<LineTone, string> = {
  default: stackStyles.lineBelowDefault,
  muted: stackStyles.lineBelowMuted,
  attention: stackStyles.lineBelowAttention,
  danger: stackStyles.lineBelowDanger,
  success: stackStyles.lineBelowSuccess,
  done: stackStyles.lineBelowDone,
}
